import React, { useCallback, useEffect, useState, useRef } from "react";
import { useError } from "../../context/errorContext";
import CloseIcon from '@mui/icons-material/Close';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import axiosInstance from "../../api/axiosInstance";
import useModalClose from "../../hooks/useModalClose";
import moment from 'moment';

const ChangeUserPermissions = ({ id, onClose }) => {
    const [isLoading, setLoading] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const [resources, setResources] = useState([]);
    const [resource, setResource] = useState("");

    const containerRef = useRef(null);

    useModalClose(containerRef, onClose);

    const { showMessage } = useError();

    const fetchData = useCallback(async () => {
        try {
            const [permissionsRes, resourcesRes] = await Promise.all([
                axiosInstance.get(`userpermissions/${id}`),
                axiosInstance.get(`forms/resources`)
            ]);

            setPermissions(permissionsRes.data);
            setResources(resourcesRes.data);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, [id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleAddPermissions = async (selectedResource) => {
        try {
            await axiosInstance.post(`userpermissions`, {
                id,
                resource: selectedResource
            });

            showMessage("Rechte geändert!");
            setResource("");
            fetchData();
        } catch (err) {
            console.error(err);
            showMessage("Fehler beim Hinzufügen!");
        }
    };

    const handleDeletePermissions = async ({ id }) => {
        try {
            await axiosInstance.delete(`userpermissions/${id}`);
            showMessage("Rechte entfernt!");
            fetchData();
        } catch (err) {
            console.error("Fehler beim Löschen der Rechte:", err);
            showMessage("Fehler beim Entfernen der Rechte!");
        }
    };

    if (isLoading) return null;

    return (
        <div className="background">
            <div className="modal middle" ref={containerRef}>
                <div className="topBar">
                    <h5>Rechte anpassen</h5>
                    <button className="closeBtn" onClick={onClose}><CloseIcon /></button>
                </div>
                <form onSubmit={(e) => { e.preventDefault(); handleAddPermissions(); }}>
                    {permissions.map((permission) => (
                        <div className="groupList" key={permission.id}>
                            <span className="role">{permission.resource}</span>
                            <div className="right">
                                <span>{moment(permission.createdAt).fromNow()}</span>
                                <RemoveCircleOutlineOutlinedIcon onClick={() => handleDeletePermissions(permission)} />
                            </div>
                        </div>
                    ))}
                    <div className="groupInput">
                        <select autoFocus value={resource} onChange={(e) => {
                            const selectedResource = e.target.value;
                            setResource(selectedResource);
                            handleAddPermissions(selectedResource);
                        }}
                        >
                            <option value="" disabled hidden>Ressource wählen</option>
                            {resources.map((resource) => (
                                <option key={resource.name} value={resource.name}>{resource.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button onClick={onClose} className="light">Abbrechen</button>
                        </div>
                    </div >
                </form >
            </div>
        </div >
    );
};

export default ChangeUserPermissions;